import { Skeleton } from '@mint-lib/tw-components';

export const BaseSummarySkeleton = () => {
  return (
    <div data-testid="summary-skeleton">
      <div className="mb-1.5 flex gap-1">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-6 w-32" />
      </div>
      <Skeleton className="mt-1 h-8 w-1/3" />
    </div>
  );
};
